<template>
  <v-flex>
    <v-row>
      <v-col cols="12" :sm="12" :md="6" :lg="6">
        <chart-card-container icon="mdi-chart-line-variant" title="Activity trend">
          <template slot="chart">
<!--            <trend-line :profile="profile" :avg="companyEngagementAvg" v-if="profile"></trend-line>-->
            <trend-line :profile="profile" :company-avg="companyAvg" v-if="isStaff"></trend-line>
            <trend-line-scouting :profile="profile" :company-avg="companyAvg" v-else></trend-line-scouting>
          </template>
        </chart-card-container>
      </v-col>
      <v-col cols="12" :sm="12" :md="6" :lg="6">
        <chart-card-container icon="mdi-chart-bar" title="Changes by section">
          <template slot="chart">
            <sections-changes-bars :profile="profile" v-if="profile"></sections-changes-bars>
          </template>
        </chart-card-container>
      </v-col>
    </v-row>

    <visualize-changes :profile="profile" v-if="profile && showChanges"></visualize-changes>
  </v-flex>
</template>

<script>
  import TrendChanges from "../Charts/Profile/trendChanges";

  import ChartCardContainer from "../Charts/chartCardContainer";
  import TrendLine from "../Charts/Profile/trendLine";
  import SectionsChangesBars from "../Charts/Profile/sectionsChangesBars";
  import VisualizeChanges from "../Widgets/visualizeChanges";
  import TrendLineScouting from "../Charts/Profile/trendLineScouting";

  export default {
    name: "profileLinUpdates",
    components: {
      TrendLineScouting,
      VisualizeChanges, SectionsChangesBars, TrendLine, ChartCardContainer, TrendChanges},
    props: {
      profile: {
        type: Object
      },
      companyAvg: {
        type: Array
      },
      showChanges: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        selectedDates: [],
      }
    },
    computed: {
      isStaff(){
        return this.profile && this.profile.groups.indexOf('staff') > -1
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TabContents/profileLinUpdates.vue